// Puerto de packages/hce/src/hce/paciente/ProblemasTab.tsx.
import { useSearchResources } from '@medplum/react-hooks';
import type { Condition } from '@medplum/fhirtypes';
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { TablaVacia } from './TablaVacia';

export function ProblemasTab(): JSX.Element {
  const { t } = useTranslation();
  const { id } = useParams() as { id: string };
  const [condiciones, cargando] = useSearchResources('Condition', { patient: `Patient/${id}`, _sort: '-recorded-date', _count: 100 });

  if (cargando) return <p className="text-sm text-muted-foreground">{t('fichaPaciente.cargando')}</p>;
  const lista = (condiciones ?? []) as Condition[];
  if (lista.length === 0) return <TablaVacia mensaje={t('fichaPaciente.sinDatos')} />;

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>{t('fichaPaciente.columnas.fecha')}</TableHead>
          <TableHead>{t('fichaPaciente.columnas.diagnostico')}</TableHead>
          <TableHead>{t('fichaPaciente.columnas.codigo')}</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {lista.map((c) => (
          <TableRow key={c.id}>
            <TableCell>{c.recordedDate ? new Date(c.recordedDate).toLocaleDateString('es-EC') : '—'}</TableCell>
            <TableCell>{c.code?.text ?? c.code?.coding?.[0]?.display ?? '—'}</TableCell>
            <TableCell>{c.code?.coding?.[0]?.code ?? '—'}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
